import RPTQuickLinksTable from 'components/CIMSTable/common/components/RPTQuickLinksTable'
import {
  useCreateIssueQuickLinkMutation,
  useEditIssueQuickLinkMutation,
  useIssueQuickLinksQuery,
  useRestoreIssueQuickLinkMutation,
  useSoftRemoveIssueQuickLinkMutation,
} from 'schema'
import { Permission } from 'shared'

const IssueQuickLinks: React.FC = () => (
  <RPTQuickLinksTable
    entity="Issue"
    query={useIssueQuickLinksQuery}
    getQuickLinks={(data) => data?.issueQuickLinks?.records ?? []}
    restore={{
      permission: Permission.RemoveRestoreIssueQuickLink,
      mutation: useRestoreIssueQuickLinkMutation,
      getLabel: ({ restoreIssueQuickLink: restore }) => restore.quickLink,
    }}
    create={{
      permission: Permission.CreateIssueQuickLink,
      mutation: useCreateIssueQuickLinkMutation,
      getLabel: ({ createIssueQuickLink: create }) => create.quickLink,
    }}
    edit={{
      permission: Permission.EditIssueQuickLink,
      mutation: useEditIssueQuickLinkMutation,
      getLabel: ({ editIssueQuickLink: edit }) => edit.quickLink,
    }}
    remove={{
      permission: Permission.RemoveRestoreIssueQuickLink,
      mutation: useSoftRemoveIssueQuickLinkMutation,
      getLabel: ({ softRemoveIssueQuickLink: remove }) => remove.quickLink,
    }}
  />
)

export default IssueQuickLinks
